/* eslint-disable complexity */
import React from 'react'
import { withRouter } from 'react-router-dom'
import moment from 'moment'
import Shell from '../Shell/Shell'
import styles from './Appointment.module.css'
import ErrorQuery from '../Error404/Error404'
import Middleware from '../../Api/Middleware'
import Branches from '../Branches/Branches'
import LoaderFullScreen from '../LoaderFullScreen/LoaderFullScreen'
import Utils from '../../Utils/utils'
import {
  CENTER_STEP, DATE_STEP, ACCEPT_STEP, SUCCESS_STEP
} from '../../Utils/constants'
import ChooseDates from '../ChooseDates/ChooseDates'
import Accept from '../Accept/Accept'
import Success from '../Success/Success'
import apiAcuity from '../../Api/Acuity'
import { setTrackingPatient } from '../../Utils/tracking';

/**
 * Appointment Component
 * @return {void}
 */
class Appointment extends React.Component {
  /**
   * Constructor
   * @param {*} props .
   */
  constructor(props) {
    super(props)
    this.state = {
      steps: [
        {
          name: CENTER_STEP,
          current: true
        },
        {
          name: DATE_STEP,
          current: false
        },
        {
          name: ACCEPT_STEP,
          current: false
        },
        {
          name: SUCCESS_STEP,
          current: false
        }
      ],
      error: false,
      patient: {},
      branches: [],
      currentBranch: '',
      dateSelected: '',
      timeZone: true,
      appointment: '',
      appointmentId: '',
      onsite: false
    }
  }

  /**
   * Component Did Mount
   * @return {void}
   */
  componentDidMount = () => {
    const { match } = this.props
    const params = match && match.params ? match.params : null
    const PublicKey = params ? params.publicKey : ''
    const onsite = params ? params.onsite : false
    this.setState({onsite})

    Middleware.getTable(process.env.REACT_APP_MIDDLEWARE_ITEM, 'Patient', null, { PublicKey }, this.success, this.error)
  }

  /**
   * Component Did Update
   * @param {Object} nextProps .
   * @param {Object} nextState .
   * @return {void}
   */
  componentDidUpdate(nextProps, nextState) {
    const { patient, branches } = this.state
    if (patient && patient !== nextState.patient) {
      setTrackingPatient(patient)
      const Country = patient.Country_Ops
      const order = {
        type: 'asc',
        column: 'Order'
      }
      Middleware.getTable(process.env.REACT_APP_MIDDLEWARE_ITEMS, 'SmileCenter', order, { Country }, this.success, this.error)
    }
    if (branches && branches !== nextState.branches) {
      if(branches.length == 1){
        this.setCurrentBranch(branches[0])
      }
      patient && this.analyzeStatus(patient)
    }
  }

  /**
   * Success Function
   * @param {object} data .
   * @return {void}
   */
  success = (data) => {
    const patient = data.Patient
    const branches = data.items

    if (patient && patient.Patient_Name.indexOf(' ') === -1) {
      this.setState({
        error: {
          message: 'Faltan los apellidos del paciente'
        }
      })
    }

    patient && this.setState({ patient })
    branches && this.filterBranches(branches)
  }

  filterBranches = (branches) => {
    const newBranches = branches.filter(branch => branch.Appointment_Type && branch.Appointment_Type === process.env.REACT_APP_APPOINTMENT_TYPE)
    this.setState({ branches: newBranches })
  }

  /**
   * Error Function
   * @param {object} error .
   * @return {void}
   */
  error = (error) => {
    this.setState({ error })
  }

  /**
   * Analyze Status
   * @param {object} patient .
   * @return {void}
   */
  analyzeStatus = (patient) => {
    const { branches } = this.state

    const appointmentTypeID = patient && patient.Appointment_Type_Id
    const appointmentId = patient && patient.Appointment_Id
    const appointmentStatus = patient && patient.Appointment_Status
    let appointmentDate = patient && patient.Appointment_Date && patient.Appointment_Date.iso
    appointmentDate = moment(appointmentDate)
    const now = moment()

    const currentBranch = Array.isArray(branches)
      && branches.filter(branch => branch.Appointment_Type_Id.toString() === appointmentTypeID)[0]

    if (appointmentStatus === 'Scheduled' || appointmentStatus === 'Confirmed') {
      currentBranch && this.setState({ currentBranch })
      appointmentDate && this.setState({ dateSelected: appointmentDate })
      if (appointmentDate > now) {
        this.goToSpecificsStep(SUCCESS_STEP)
        this.setState({ timeZone: false })
      }
    }

    appointmentId && this.setState({ appointmentId })
  }

  /**
   * Go To Specifics Step
   * @param {String} stepName .
   * @return {void}
   */
  goToSpecificsStep = (stepName) => {
    const { steps } = this.state
    const newSteps = JSON.parse(JSON.stringify(steps))

    const indexCurrentStep = steps.findIndex(step => step.current === true)
    const nextIndex = steps.findIndex(step => step.name === stepName)

    newSteps[indexCurrentStep].current = false
    newSteps[nextIndex].current = true
    this.setState({ steps: newSteps })
  }

  /**
   * Select Time
   * @param {String} time .
   * @return {void}
   */
  selectTime = (time) => {
    this.setState({ dateSelected: time })
    this.nextStep()
  }

  /**
   * Set Appointment
   * @param {Object} appointment .
   * @return {void}
   */
  setAppointment = (appointment) => {
    this.setState({ appointment })
    this.nextStep()
  }

  /**
   * Set Current Branch
   * @param {object} currentBranch .
   * @return {void}
   */
  setCurrentBranch = (currentBranch) => {
    this.setState({ currentBranch })
    this.nextStep()
  }

  /**
   * New Appointment
   * @return {void}
   */
  cancelAppointment = async () => {
    const { appointment, appointmentId } = this.state
    let response = ''
    if (appointment) response = await apiAcuity.cancel(appointment.id)
    else if (appointmentId) response = await apiAcuity.cancel(appointmentId)
    this.setState({ timeZone: true })
    return response
  }

  /**
   * Next Steps
   * @param {object} isBack .
   * @return {void}
   */
  nextStep = (isBack = false) => {
    const { steps } = this.state
    const newSteps = JSON.parse(JSON.stringify(steps))
    let count = 1
    const indexCurrentStep = steps.findIndex(step => step.current === true)

    if (isBack && indexCurrentStep > 0) count = -1
    else if (isBack && indexCurrentStep === 0) count = 0

    if (indexCurrentStep === newSteps.length - 1) {
      newSteps[indexCurrentStep].current = false
      newSteps[0].current = true
    } else {
      newSteps[indexCurrentStep].current = false
      newSteps[indexCurrentStep + count].current = true
    }

    this.setState({ steps: newSteps })
  }

  /**
   * Render
   * @returns {void}
   */
  render() {
    const {
      error, patient, branches, currentBranch, steps,
      dateSelected, appointmentID, appointment, timeZone
    } = this.state
    window.scrollTo(0, 0)

    const userData = {
      firstName: patient && patient.Patient_Name,
      lastName: '',
      email: patient && patient.Email,
      phone: patient && patient.Phone
    }

    const userToSuccess = {
      firstName: patient && patient.Patient_Name,
      country: patient && patient.Country_Ops,
      referralCode: patient && patient.Referral_Code,
      currencyProd: patient && patient.Currency
    }

    if (error) {
      return <ErrorQuery error={error} />
    }

    if (!patient || Utils.isEmptyObject(patient) || branches.length === 0) {
      return <LoaderFullScreen />
    }

    const name = (patient && patient.Patient_Name) || ''
    const currentStep = steps.filter(step => step.current === true)[0]
    const customerId = patient && patient.CustomerId
    const publicKey = patient && patient.PublicKey
    const onsite = this.state.onsite
    const partner = currentBranch.Partner ? currentBranch.Partner : false

    return (
      <Shell>
        <div className={styles.Container}>
          <div className={styles.Wrapper}>
            {currentStep.name === CENTER_STEP && (
              <Branches
                name={name}
                items={branches}
                setCurrentBranch={this.setCurrentBranch}
              />
            )}
            {currentStep.name === DATE_STEP && (
              <ChooseDates
                branch={currentBranch}
                nextStep={this.nextStep}
                name={name}
                selectTime={this.selectTime}
                country={patient && patient.Country_Ops}
              />
            )}
          </div>
          {currentStep.name === ACCEPT_STEP && (
            <Accept
              setAppointment={this.setAppointment}
              branch={currentBranch}
              nextStep={this.nextStep}
              dateSelected={dateSelected}
              appointmentID={appointmentID}
              userData={userData}
              customerId={customerId}
              publicKey={publicKey}
              onsite={onsite}
              partner={partner}
              country={patient && patient.Country_Ops}
            />
          )}
          {currentStep.name === SUCCESS_STEP && (
            <Success
              branch={currentBranch}
              dateSelected={dateSelected}
              userData={userToSuccess}
              appointment={appointment}
              newAppointment={this.cancelAppointment}
              nextStep={this.nextStep}
              timeZone={timeZone}
            />
          )}
        </div>
      </Shell>
    )
  }
}

export default withRouter(Appointment)
